// extracted by mini-css-extract-plugin
module.exports = {"method":"_3nOiV","large":"_2Aaw-","get":"CTd6B","post":"_2khcQ","delete":"_2OMCv","put":"_1Qnp-","patch":"_1PxTo","head":"_1PXlN","options":"_1R4gY"};